import React from "react";
import "./InputErrorList.scss";
export const InputErrorList = ({ errorMessages }) => {
    return (React.createElement("div", { "data-test-id": "input-error-list" }, errorMessages === null || errorMessages === void 0 ? void 0 : errorMessages.map((error) => (React.createElement("div", { key: error, className: "input-error" }, error)))));
};
